// src/Container/Dashboard/dashboard.js

import React from 'react';
import Box from '@mui/material/Box';
import GoogleMap from '../../Components/GoogleMap/GoogleMap';

export default function Dashboard({
  activeMenu,
  setActiveMenu,
  setEditPost,
  setEventsDetails,
  activeTool,
  currentAction,
  drawingStyles,
  setDrawingStyles,
  setSelectedMarkerData,
  updateMarkerInState,
  isDrawerEditing,
  hasUnsavedChanges,
  onSelectionBlocked,
  selectedMarker,
  setGetMapCurrentState,
  onMapLoad,
  filterCriteria,
  onFilterResults,
  searchMarker,
  setSearchMarker, // Ensure this is received
}) {
  return (
    <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
      <GoogleMap
        activeMenu={activeMenu}
        activeTool={activeTool}
        setActiveTool={(tool) => {
          // Optional: You could intercept tool changes here if needed
        }}
        currentAction={currentAction}
        drawingStyles={drawingStyles}
        setDrawingStyles={setDrawingStyles}
        setSelectedMarkerData={setSelectedMarkerData}
        isDrawerEditing={isDrawerEditing}
        hasUnsavedChanges={hasUnsavedChanges}
        onSelectionBlocked={onSelectionBlocked}
        selectedMarker={selectedMarker}
        setGetMapCurrentState={setGetMapCurrentState}
        onMapLoad={onMapLoad}
        filterCriteria={filterCriteria}
        onFilterResults={onFilterResults}
        searchMarker={searchMarker}
        onClearSearchMarker={() => {
          // Check if function exists before calling to prevent crash
          if (typeof setSearchMarker === 'function') {
            setSearchMarker(null);
          }
        }}
      />
    </Box>
  );
}
